import React from 'react';

export default
<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
    <g transform="translate(6.000000, 3.000000)" stroke="currentColor">
        <path key="1" d="M15,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,27 C0,28.6568542 1.34314575,30 3,30 L21,30 C22.6568542,30 24,28.6568542 24,27 L24,9 L15,0 Z" strokeWidth="2" strokeLinecap="round"/>
        <polygon key="2" strokeWidth="2" fill="currentColor" strokeLinecap="round" points="15 0 15 9 24 9"/>
        <path key="3" d="M18,16.5 L6,16.5" id="Path" strokeWidth="1.6" strokeLinecap="square"/>
        <path key="4" d="M18,22.5 L6,22.5" id="Path" strokeWidth="1.6" strokeLinecap="square"/>
        <polyline key="5" strokeWidth="1.6" strokeLinecap="square" points="10 10.5 8 10.5 6 10.5"/>
    </g>
</g>;
